export default __webpack_public_path__ + "static/shopify-bbfd1135daeec5b07ba7d6093ac6a640.png";